import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ApiResponseInterface } from '../shared/interfaces/common.interface';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(
    private localStorageService: LocalStorageService,
    private api: ApiService
  ) { }


  /**
   * Updates field by id
   * @param payload
   * @returns field by id
   */
  updateProfile(payload: any): Observable<ApiResponseInterface> {
    const userId = this.localStorageService.get('user_id');
    return this.api.PATCH(`user/${userId}`, payload);
  }

  /**
   * Profiles data
   * @returns
   */
  profileData() {
    return this.api.GET(`user/me`)
  }

}
